//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
const FIXED_CUSTOM_PLAN_PRICE = 399

export default {
  mixins: [blok],
  data () {
    return {
      FIXED_CUSTOM_PLAN_PRICE,

      priceListOriginal: null,
      priceListVariant: null,
      isVariant: false,

      detailsOpen: false,
      pricing: [],
      period: 'year',

      hasSmallPrint: this.$sb.isFilledRichText(this.blok.small_print),
      hasAfterword: this.$sb.isFilledRichText(this.blok.afterword),
    }
  },
  async fetch () {
    const priceListName = this.$country.isFinland() ? 'current' : 'pricing-test'
    try {
      this.priceListOriginal = await this.$api.getPriceList(priceListName).then(r => r.data)

      // Filter out plans that are only for upgrade
      this.priceListOriginal.items = this.priceListOriginal.items.filter(item => item.data.upgrade_only !== true)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  },
  computed: {
    priceList () {
      return (this.isVariant && this.priceListVariant) ? this.priceListVariant : this.priceListOriginal
    },
    bgImg () {
      return this.$sb.parseImage(this.blok.bg_img)
    },
    isPriceListV2 () {
      return this.priceList?.data_version === 'v2'
    },
    isPriceListV1_1 () {
      return this.priceList?.data_version === 'v1.1'
    },
    contactButtonUrl () {
      try {
        const demoUrl = this.$url.demo()
        return demoUrl
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e)
        return this.$url.contactUs()
      }
    },
    monthly: {
      get () {
        return this.period === 'month'
      },
      set (monthly) {
        if (monthly) {
          this.period = 'month'
        } else {
          this.period = 'year'
        }
      }
    },
  },
  methods: {
    promotedFeaturesForItem (item) {
      return item.data.promoted_features.map((pf) => {
        // promoted features can be either strings (so they are id from features) or
        // objects so they are completely custom rows defined for the item
        if (typeof pf === 'string') {
          const feature = this.priceList.data.features.find(f => f.id === pf)
          const planFeature = item.data.features.find(f => f.id === pf)
          if (!feature || !planFeature) {
            return null
          }

          return {
            id: pf,
            title: feature.title,
            value: planFeature.value,
            description: planFeature.description || feature.description,
          }
        }

        return {
          id: pf.title,
          title: pf.title,
          value: pf.value,
          description: pf.description,
        }
      }).filter(f => !!f)
    },
    getPrice (item) {
      return item.prices.find(p => this.monthly ? p.period_unit === 'month' : p.period_unit === 'year')
    }
  }
}
